<template>
  <div>
    <ul>
      <li v-for="suborder in dataList"
          v-bind:key = "suborder.point_id">
        <GeocodingUlItem :suborder="suborder"
                         :dateRange="dateRange"
                         @AddExamples="AddExamples"
                         @selected="selectFunc(suborder)"></GeocodingUlItem>
      </li>
    </ul>
  </div>
</template>

<script>

import moment from 'moment';
// eslint-disable-next-line import/extensions
import GeocodingUlItem from './GeocodingUlItem';

export default {
  name: 'geo-soc-ul',
  components: {
    GeocodingUlItem,
  },
  props: {
    dataList: {
      type: Array,
    },
    dateRange: {
      type: Object,
    },
  },
  data() {
    return {
      list: [],
      newPage: null,
    };
  },
  filters: {
    splited(date) {
      return moment(date.split('T')[0]).format('D MMM');
    },
  },
  methods: {
    AddExamples(id, examples) {
      this.$emit('AddExamples', id, examples);
    },
    selectFunc(item) {
      this.$emit('selected', item);
    },
  },
  watch: {
    dataList() {
      this.list = this.dataList;
    },
  },
};
</script>

<style lang="scss" scoped>
  ul {
    max-height: 550px;
    min-height: 100px;
    overflow-x: hidden;
    padding: 0;
    margin: 0;
    border-bottom: 1px solid #d2d2d2;
    border-right: 5px solid #fafafa;
    &::-webkit-scrollbar {
       display: none;  /* Safari and Chrome */
    }
  }
  li {
    font-family: "Lato", sans-serif;
    min-height: 44px;
    font-size: 14px;
    width: 100%;
    list-style-type: none;
  }
  .delete-soc {
    float: right;
    padding: 3px 0;
    color: #9B9B9B;
  }
  .delete-soc:hover {
    color: orangered;
  }
  .fa-stack {
    font-size: 0.6em;
    padding-bottom: 2px;
  }
  i { vertical-align: middle; }
  .req-at{
    float: right;
    margin-right: 4px;
  }
  .non-clickeable {
    font-size: 7px;
    padding-top: 3px;
    margin-right: 3px;
    float: right;
    color: darkgray;
  }
  .clickeable {
    font-size: 7px;
    padding-top: 3px;
    margin-right: 3px;
    float: right;
    color: darkgray;
    cursor: pointer;
    animation: jumps .5s infinite;
  }
  .clickeable:hover {
    color: #AAD500;
    animation: none;
  }
  @keyframes jumps {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(4px);
    }
    100% {
      transform: translateY(0px);
    }
  }
  .item-container {
    padding: 5px 2px;
    text-align: left !important;
  }
  .point-package {
    color: darkgray;
  }
  .point-map {
    color: #E6A23C;
    font-size: 8px;
    top: -0.5px;
  }
  .locality-tag{
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-left: 10px;
    max-width: calc(100% - 14ch - 110px);
  }
</style>
